export default defineAppConfig({
  site: {
    // Account "Latvia" (token qhdq) is resolved by defaultCountryIso → detect-by-country/lv.
    orgName: 'Bībeles skola',
    logoLines: { line1: 'BĪBELES', line2: 'SKOLA' },
    defaultCountryIso: 'lv',
    geoDetect: false,
    showRegionField: false,
    showExpertsSection: false,
    // Contacts are empty on the account (contact_phone/email = ''); leave null until provided.
    phone: null as string | null,
    phoneTel: null as string | null,
    email: null as string | null,
    supportUrl: null as string | null, // account contact_pay: false
  },
})
